import axios from 'axios';
import { msgTypes } from 'constants/msgTypes';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthService } from 'services/auth/AuthService';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import showAlert from 'services/shared/alert';
import { UtilService } from 'services/shared/UtilService';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'react-quill/dist/quill.snow.css';


axios.interceptors.request.use(

  async (config) => {
    const isLoginUrl = config.url.includes('admin/auth/login')
    if(!isLoginUrl){
        const token = await LocalStorageService.getToken();
        if (token) {
          if (token != null && token != 'null') {
            config.headers['Authorization'] = "Bearer " + token;
            return config;
          }
        }
        return config;
    }else{
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

//Interceptor for response body
axios.interceptors.response.use(
  async (response) => {
    let responseValue = new ResponseModel();
    try {

      const decryptRes = await AuthService.getDecryptText(JSON.parse(response.data));
      responseValue = JSON.parse(decryptRes);

      if (responseValue?.statusMsg === msgTypes.SUCCESS.msg) {
        if (responseValue.displayAlert === true) {
          showAlert(responseValue.statusMsg, responseValue.statusRemark, msgTypes.success, msgTypes.OK_KEY);
        }
        return (response);
      }else{
        if (responseValue.displayAlert === true) {
          showAlert(responseValue.statusMsg, responseValue.statusRemark, msgTypes.error, msgTypes.OK_KEY);
        }
      }
    } catch (error) {
      showAlert(responseValue.statusMsg, responseValue.statusRemark, msgTypes.error, msgTypes.OK_KEY);
    }
  },
  (error) => {
    if(error.code ==='ERR_NETWORK'){
      showAlert(UtilService.upperCase(msgTypes.error), "Network Error", msgTypes.error, msgTypes.OK_KEY);  
    }else{
      showAlert(UtilService.upperCase(msgTypes.error), msgTypes.SOMETHING_WENT_WRONG, msgTypes.error, msgTypes.OK_KEY);
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
